import AsyncSelect from "react-select/async";
import { useCallback, useContext, useMemo } from "react";
import { FormControl, FormHelperText } from "@mui/material";

import { Context } from "../../Provider";
import InputRequired from "../../../common/InputRequired";

const VehicleColors = ({ setValue, errors = {} }) => {
    const { state } = useContext(Context);
    const { vehicle_colors = [] } = state.commonSettings ?? {};

    /* ------------------ Map brands once ------------------ */
    const options = useMemo(
        () =>
            vehicle_colors.map(({ vehicle_color_name }) => ({
                value: vehicle_color_name,
                label: vehicle_color_name,
            })),
        [vehicle_colors]
    );

    /* ------------------ Async filter (FIXED) ------------------ */
    const loadOptions = useCallback(
        (inputValue) => {
            if (!inputValue) {
                return Promise.resolve(options);
            }

            const search = inputValue.toLowerCase();
            const filtered = options.filter(option =>
                option.label.toLowerCase().includes(search)
            );

            return Promise.resolve(filtered);
        },
        [options]
    );

    /* ------------------ Styles ------------------ */
    const selectStyles = useMemo(
        () => ({
            control: (base) => ({
                ...base,
                width: "100%",
            }),
            option: (base, state) => ({
                ...base,
                backgroundColor:
                    state.isSelected || state.isFocused ? "#8bd68fff" : "#fff",
                color:
                    state.isSelected || state.isFocused ? "#fff" : "#333",
            }),
        }),
        []
    );

    /* ------------------ Change handler (SAFE) ------------------ */
    const handleChange = useCallback(
        (option) => {
            const value = option?.value || null;
            setValue("ftm_vehicle_color", value, { shouldValidate: true });
        },
        [setValue]
    );

    return (
        <FormControl error={!!errors?.ftm_vehicle_color} fullWidth>
            <div className="mt-1 mb-3">
                <strong>
                    Vehicle color <InputRequired />
                </strong>

                <div className="d-flex align-items-center gap-2 mt-1">
                    <div className="flex-grow-1">
                        <AsyncSelect
                            cacheOptions
                            defaultOptions={options}
                            loadOptions={loadOptions}
                            placeholder="Select vehicle color"
                            isClearable
                            styles={selectStyles}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                {errors?.ftm_vehicle_color && (
                    <FormHelperText>
                        {errors.ftm_vehicle_color.message}
                    </FormHelperText>
                )}
            </div>
        </FormControl>
    );
};

export default VehicleColors;